mobileSize = 1000;

$(document).ready(function(){
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1001) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1000) {
    $('body').removeClass('saffireMobileSize');
  }

  // General Message
  $('.generalmessage').prependTo('header');

  // Replace Saffire Logo
	$('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);

  // Tier One Things
  if ($('body').hasClass('saffireMobileSize')) {
    $('#siteInfoBannerWidget').insertBefore('#mainFeature');
  } else {
    $('#siteInfoBannerWidget').prependTo('.tier-one .widget-wrapper');
  }
});

$(window).load(function(){
	$('body').addClass('pageIsLoaded');

  const tierThreeTop = $('.tier-three').offset().top + ($('.tier-three').innerHeight() / 3.5);
  const bottomOfScreen = $(window).scrollTop() + $(window).innerHeight();

  function animateContainers(val1, val2) {
    if (val2 > val1) {
      $('.tier-three .container').each(function(i) {
          const el = $(this);
          (function (i) {
            setTimeout(function () {
              el.addClass('in-view');
            }, 600*i);
          })(i);
      });
    }
  }

  if (!$('.tier-three .container').hasClass('in-view')) {
    animateContainers(tierThreeTop, bottomOfScreen);
  }

  $(window).on('scroll', function() {
    if (!$('.tier-three .container').hasClass('in-view')) {
      const tierThreeTop = $('.tier-three').offset().top + ($('.tier-three').innerHeight() / 3.5);
      const bottomOfScreen = $(window).scrollTop() + $(window).innerHeight();
      animateContainers(tierThreeTop, bottomOfScreen);
    }
  });
      
});

$(window).resize(function(){
  // Tier One Things
  if ($('body').hasClass('saffireMobileSize')) {
    $('#siteInfoBannerWidget').insertBefore('#mainFeature');
  } else {
    $('#siteInfoBannerWidget').prependTo('.tier-one .widget-wrapper');
  }
});